<template>
  <span
    :class="`mc-badge ${computedVariant} ${computedSize} ${computedType}`"
    :style="computedStyle"
  >
    <i v-if="icon" :class="`${icon} ${computedIconVariant} mc-badge-icon`"></i>
    <span v-if="text">{{ text }}</span>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'medium',
    },
    type: {
      type: String,
      default: 'button',
      required: true,
    },
    color: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    iconVariant: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedVariant() {
      const defaultVariant = 'bg-primary'
      const variantMapping = {
        primary: 'bg-primary',
        secondary: 'bg-secondary',
        success: 'bg-success',
        danger: 'bg-danger',
        warning: 'bg-warning',
        info: 'bg-info',
        light: 'bg-light',
        dark: 'bg-dark',
        pink: 'bg-pink',
        purple: 'bg-purple',
        canceled: 'bg-canceled',
        inprogress: 'bg-progress',
        draft: 'bg-draft',
        confirm: 'bg-confirm',
        picked: 'bg-confirm',
        confirmOrder: 'bg-confirm-order',
        scheduled: 'bg-scheduled',
        scheduledOrder: 'bg-rescheduled-order',
        rescheduled: 'bg-rescheduled',
        rescheduledOrder: 'bg-rescheduled-order',
        started: 'bg-started',
        delivered: 'bg-delivered',
        break: 'bg-break-time',
        outlinePrimary: 'mc-outline-primary',
        outlineSecondary: 'mc-outline-secondary',
        outlineSuccess: 'mc-outline-success',
        outlineDanger: 'mc-outline-danger',
        outlineWarning: 'mc-outline-warning',
        outlineInfo: 'mc-outline-info',
        outlineDark: 'bg-outline-dark',
        outlinePink: 'mc-outline-pink',
        outlinePurple: 'mc-outline-purple',
      }

      return variantMapping[this.variant] || defaultVariant
    },

    computedIconVariant() {
      if (!this.iconVariant) return ''

      const variantMapping = {
        primary: 'icon-primary',
        secondary: 'icon-secondary',
        success: 'icon-success',
        danger: 'icon-danger',
        warning: 'icon-warning',
      }

      return variantMapping[this.iconVariant] || ''
    },

    computedSize() {
      const defaultSize = 'mc-badge--medium'
      const sizeMapping = {
        small: 'mc-badge--small',
        medium: 'mc-badge--medium',
        large: 'mc-badge--large',
      }

      return sizeMapping[this.size] || defaultSize
    },

    computedType() {
      const defaultType = 'mc-badge--button'
      const typeMapping = {
        pill: 'mc-badge--pill',
        button: 'mc-badge--button',
        status: 'mc-badge--status',
        notif: 'mc-badge--notif',
      }

      return typeMapping[this.type] || defaultType
    },

    computedStyle() {
      if (this.color) {
        return {
          backgroundColor: `${this.color} !important`,
        }
      }

      return {}
    },
  },
}
</script>
